import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app-config.service';
import { CybermetrieService } from '@oel/js-cybermetrie';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  static isInitialise: boolean;

  constructor(private readonly _appConfigService: AppConfigService) {
    this.initialiser();
  }

  protected initialiser() {
    if (GtmService.isInitialise) {
      // Sécurité pour éviter des boucles d'initialisation infinie dans la webview
      // dans un cas où le GtmService serait provided dans un autre module et 
      // que le GtmService ne serait plus un singleton.
      console.warn('La cybermétrie est déjà initialisée');
      return;
    }

    CybermetrieService.initialiser();
    GtmService.isInitialise = true;
  }

  pushEvent(data, dimensionsPersonnalisees?: Map<string, string>) {
    if (typeof CybermetrieService === 'undefined') {
      console.warn('Can not push event, CybermetrieService not defined');
      return;
    }

    CybermetrieService.envoyerEvenement(data, dimensionsPersonnalisees);
  }

  get urlProvenance() {
    return this._appConfigService.configData ? this._appConfigService.urlRetour : null;
  }
}
